import React, { Component } from "react";
import PreAtendimennto from "../build/images/atendance_clear.svg";

export default class Attendance extends Component {
  render() {
    return (
      <div
        id="column2"
        // className="chat-page column split column-chat"
        className="chat-page column column-chat"
        style={{ width: "100%" }}
      >
        <div className="block full-height no-margin-bottom" id="chat">
          <div className="block-content chat-canvas">
            <img className="chat-canvas__img" src={PreAtendimennto} alt="" />
          </div>
        </div>
      </div>
    );
  }
}
